"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.getFontString = void 0;

var _HelveticaNeueLTProRoman = _interopRequireDefault(require("../assets/fonts/helveticaneue/HelveticaNeueLTPro-Roman.woff2"));

var _HelveticaNeueLTProBdCn = _interopRequireDefault(require("../assets/fonts/helveticaneue/HelveticaNeueLTPro-BdCn.woff2"));

var _HelveticaNeueLTProRoman2 = _interopRequireDefault(require("../assets/fonts/helveticaneue/HelveticaNeueLTPro-Roman.woff"));

var _HelveticaNeueLTProBdCn2 = _interopRequireDefault(require("../assets/fonts/helveticaneue/HelveticaNeueLTPro-BdCn.woff"));

var _FuturaPTBook = _interopRequireDefault(require("../assets/fonts/futura/FuturaPT-Book.woff2"));

var _FuturaPTBold = _interopRequireDefault(require("../assets/fonts/futura/FuturaPT-Bold.woff2"));

var _TTNormsProRegular = _interopRequireDefault(require("../assets/fonts/ttnorms/TTNormsPro-Regular.woff2"));

var _TTNormsProBold = _interopRequireDefault(require("../assets/fonts/ttnorms/TTNormsPro-Bold.woff2"));

var _TTNormsProBoldItalic = _interopRequireDefault(require("../assets/fonts/ttnorms/TTNormsPro-BoldItalic.woff2"));

var _TTNormsProBoldItalic2 = _interopRequireDefault(require("../assets/fonts/ttnorms/TTNormsPro-BoldItalic.woff"));

var _TTNormsProItalic = _interopRequireDefault(require("../assets/fonts/ttnorms/TTNormsPro-Italic.woff2"));

var _TTNormsProItalic2 = _interopRequireDefault(require("../assets/fonts/ttnorms/TTNormsPro-Italic.woff"));

var _TTNormsProLight = _interopRequireDefault(require("../assets/fonts/ttnorms/TTNormsPro-Light.woff2"));

var _TTNormsProRegular2 = _interopRequireDefault(require("../assets/fonts/ttnorms/TTNormsPro-Regular.woff"));

var _TTNormsProBold2 = _interopRequireDefault(require("../assets/fonts/ttnorms/TTNormsPro-Bold.woff"));

var _TTNormsProLight2 = _interopRequireDefault(require("../assets/fonts/ttnorms/TTNormsPro-Light.woff"));

var _LatoBlack = _interopRequireDefault(require("../assets/fonts/lato/Lato-Black.woff2"));

var _LatoBold = _interopRequireDefault(require("../assets/fonts/lato/Lato-Bold.woff2"));

var _LatoRegular = _interopRequireDefault(require("../assets/fonts/lato/Lato-Regular.woff2"));

var _LatoHairline = _interopRequireDefault(require("../assets/fonts/lato/Lato-Hairline.woff2"));

var _LatoBlack2 = _interopRequireDefault(require("../assets/fonts/lato/Lato-Black.woff"));

var _LatoBold2 = _interopRequireDefault(require("../assets/fonts/lato/Lato-Bold.woff"));

var _LatoRegular2 = _interopRequireDefault(require("../assets/fonts/lato/Lato-Regular.woff"));

var _LatoHairline2 = _interopRequireDefault(require("../assets/fonts/lato/Lato-Hairline.woff"));

var _EuclidTriangleLightWebS = _interopRequireDefault(require("../assets/fonts/euclidtriangle/EuclidTriangle-Light-WebS.woff"));

var _EuclidTriangleLightWebS2 = _interopRequireDefault(require("../assets/fonts/euclidtriangle/EuclidTriangle-Light-WebS.woff2"));

var _EuclidTriangleMediumWebS = _interopRequireDefault(require("../assets/fonts/euclidtriangle/EuclidTriangle-Medium-WebS.woff2"));

var _EuclidTriangleRegularWebS = _interopRequireDefault(require("../assets/fonts/euclidtriangle/EuclidTriangle-Regular-WebS.woff2"));

var _EuclidTriangleSemiboldWebS = _interopRequireDefault(require("../assets/fonts/euclidtriangle/EuclidTriangle-Semibold-WebS.woff2"));

var _EuclidTriangleMediumWebS2 = _interopRequireDefault(require("../assets/fonts/euclidtriangle/EuclidTriangle-Medium-WebS.woff"));

var _EuclidTriangleRegularWebS2 = _interopRequireDefault(require("../assets/fonts/euclidtriangle/EuclidTriangle-Regular-WebS.woff"));

var _EuclidTriangleSemiboldWebS2 = _interopRequireDefault(require("../assets/fonts/euclidtriangle/EuclidTriangle-Semibold-WebS.woff"));

var _RivieraNightsRegular = _interopRequireDefault(require("../assets/fonts/rivieranights/RivieraNights-Regular.woff2"));

var _RivieraNightsRegular2 = _interopRequireDefault(require("../assets/fonts/rivieranights/RivieraNights-Regular.woff"));

var _RivieraNightsBold = _interopRequireDefault(require("../assets/fonts/rivieranights/RivieraNights-Bold.woff2"));

var _RivieraNightsBold2 = _interopRequireDefault(require("../assets/fonts/rivieranights/RivieraNights-Bold.woff"));

var _RivieraNightsUltralight = _interopRequireDefault(require("../assets/fonts/rivieranights/RivieraNights-Ultralight.woff2"));

var _RivieraNightsUltralight2 = _interopRequireDefault(require("../assets/fonts/rivieranights/RivieraNights-Ultralight.woff"));

var fonts = {
  horizon: {
    heading: 'Noto Sans',
    body: 'Noto Sans'
  },
  cannesLions: {
    heading: 'Futura PT',
    body: 'Noto Sans'
  },
  lionsLive: {
    heading: 'HelveticaNeueLTPro-BdCn',
    body: 'HelveticaNeueLTPro-Roman'
  },
  money2020: {
    heading: 'TT Norms',
    body: 'TT Norms'
  },
  spikes: {
    heading: 'Arial',
    body: 'Verdana'
  },
  ascential: {
    heading: 'Lato',
    body: 'Lato'
  },
  dcl: {
    heading: 'EuclidTriangle Medium',
    body: 'EuclidTriangle Light',
    normal: 'EuclidTriangle Regular',
    medium: 'EuclidTriangle Medium',
    bold: 'EuclidTriangle Semibold'
  },
  lionsCreativity: {
    heading: 'Riviera Nights Ultralight',
    body: 'Riviera Nights Regular',
    normal: 'Riviera Nights Regular',
    bold: 'Riviera Nights Bold'
  }
};
var defaultFontString = "@font-face {\n  font-family: 'Noto Sans';\n  src: url(https://fonts.gstatic.com/s/notosans/v9/o-0IIpQlx3QUlC5A4PNr5TRASf6M7Q.woff2) format('woff2');\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Noto Sans';\n  src: url(https://fonts.gstatic.com/s/notosans/v9/o-0NIpQlx3QUlC5A4PNjXhFVZNyBx2pqPA.woff2) format('woff2');\n  font-weight: bold;\n  font-display: swap;\n  font-style: normal;\n}";

var getFontString = function getFontString(brand) {
  var fontString;

  switch (brand) {
    case 'horizon':
      fontString = '';
      break;

    case 'spikes':
    case 'cannesLions':
      fontString = "@font-face {\n          font-family: 'Futura PT';\n          font-weight: normal;\n          font-style: normal;\n          font-display: swap;\n          src: url(".concat(_FuturaPTBook.default, ") format('woff2');\n        }\n\n        @font-face {\n          font-family: 'Futura PT';\n          font-weight: bold;\n          font-style: normal;\n          font-display: swap;\n          src: url(").concat(_FuturaPTBold.default, ") format('woff');\n        }");
      break;

    case 'lionsLive':
      fontString = "@font-face {\n          font-family: 'HelveticaNeueLTPro-Roman';\n          font-weight: normal;\n          font-style: normal;\n          font-display: swap;\n          src: url(".concat(_HelveticaNeueLTProRoman.default, ") format('woff2'), url(").concat(_HelveticaNeueLTProRoman2.default, ") format('woff');\n        }\n\n        @font-face {\n            font-family: 'HelveticaNeueLTPro-BdCn';\n            font-weight: bold;\n            font-style: normal;\n            font-display: swap;\n            src: url(").concat(_HelveticaNeueLTProBdCn.default, ") format('woff2'), url(").concat(_HelveticaNeueLTProBdCn2.default, ") format('woff');\n          }");
      break;

    case 'money2020':
      fontString = "@font-face {\n          font-family: 'TT Norms';\n          font-weight: bold;\n          font-style: normal;\n          font-display: swap;\n          src: url(".concat(_TTNormsProBold.default, ") format('woff2'), url(").concat(_TTNormsProBold2.default, ") format('woff');\n        }\n\n        @font-face {\n          font-family: 'TT Norms';\n          font-weight: 800;\n          font-style: normal;\n          font-display: swap;\n          src: url(").concat(_TTNormsProBold.default, ") format('woff2'), url(").concat(_TTNormsProBold2.default, ") format('woff');\n        }\n\n        @font-face {\n          font-family: 'TT Norms Bold Italic';\n          font-weight: 800;\n          font-style: italic;\n          font-display: swap;\n          src: url(").concat(_TTNormsProBoldItalic.default, ") format('woff2'), url(").concat(_TTNormsProBoldItalic2.default, ") format('woff');\n        }\n\n        @font-face {\n          font-family: 'TT Norms Italic';\n          font-weight: 400;\n          font-style: italic;\n          font-display: swap;\n          src: url(").concat(_TTNormsProItalic.default, ") format('woff2'), url(").concat(_TTNormsProItalic2.default, ") format('woff');\n        }\n\n        @font-face {\n          font-family: 'TT Norms';\n          font-weight: normal;\n          font-style: normal;\n          font-display: swap;\n          src: url(").concat(_TTNormsProRegular.default, ") format('woff2'), url(").concat(_TTNormsProRegular2.default, ") format('woff');\n        }\n\n        @font-face {\n          font-family: 'TT Norms';\n          font-weight: normal;\n          font-style: italic;\n          font-display: swap;\n          src: url(").concat(_TTNormsProLight.default, ") format('woff2'), url(").concat(_TTNormsProLight2.default, ") format('woff');\n        }");
      break;

    case 'ascential':
      fontString = "@font-face {\n            font-family: 'Lato';\n            font-weight: bold;\n            font-style: normal;\n            font-display: swap;\n            src: url(".concat(_LatoBold.default, ") format('woff2'), url(").concat(_LatoBold2.default, ") format('woff');\n          }\n\n          @font-face {\n            font-family: 'Lato';\n            font-weight: 800;\n            font-style: normal;\n            font-display: swap;\n            src: url(").concat(_LatoBlack.default, ") format('woff2'), url(").concat(_LatoBlack2.default, ") format('woff');\n          }\n\n          @font-face {\n            font-family: 'Lato';\n            font-weight: normal;\n            font-style: normal;\n            font-display: swap;\n            src: url(").concat(_LatoRegular.default, ") format('woff2'), url(").concat(_LatoRegular2.default, ") format('woff');\n          }\n\n          @font-face {\n            font-family: 'Lato';\n            font-weight: normal;\n            font-style: italic;\n            font-display: swap;\n            src: url(").concat(_LatoHairline.default, ") format('woff2'), url(").concat(_LatoHairline2.default, ") format('woff');\n          }\n\n          @font-face {\n            font-family: 'Lato';\n            font-weight: 100;\n            font-style: normal;\n            font-display: swap;\n            src: url(").concat(_LatoHairline.default, ") format('woff2'), url(").concat(_LatoHairline2.default, ") format('woff');\n          }");
      break;

    case 'dcl':
      fontString = "@font-face {\n        font-family: 'EuclidTriangle Regular';\n        font-weight: 400;\n        font-style: normal;\n        font-display: swap;\n        src: url(".concat(_EuclidTriangleMediumWebS.default, ") format('woff2'), url(").concat(_EuclidTriangleMediumWebS2.default, ") format('woff');\n      }\n\n      @font-face {\n        font-family: 'EuclidTriangle Light';\n        font-weight: 200;\n        font-style: normal;\n        font-display: swap;\n        src: url(").concat(_EuclidTriangleLightWebS.default, ") format('woff2'), url(").concat(_EuclidTriangleLightWebS2.default, ") format('woff');\n      }\n\n      @font-face {\n        font-family: 'EuclidTriangle Medium';\n        font-weight: 500;\n        font-style: normal;\n        font-display: swap;\n        src: url(").concat(_EuclidTriangleRegularWebS.default, ") format('woff2'), url(").concat(_EuclidTriangleRegularWebS2.default, ") format('woff');\n      }\n\n      @font-face {\n        font-family: 'EuclidTriangle Semibold';\n        font-weight: 700;\n        font-style: normal;\n        font-display: swap;\n        src: url(").concat(_EuclidTriangleSemiboldWebS.default, ") format('woff2'), url(").concat(_EuclidTriangleSemiboldWebS2.default, ") format('woff');\n      }");
      break;

    case 'lionsCreativity':
      fontString = "@font-face {\n        font-family: 'Riviera Nights Regular';\n        font-weight: 400;\n        font-style: normal;\n        font-display: swap;\n        src: url(".concat(_RivieraNightsRegular.default, ") format('woff2'), url(").concat(_RivieraNightsRegular2.default, ") format('woff');\n      }\n\n      @font-face {\n        font-family: 'Riviera Nights Bold';\n        font-weight: 500;\n        font-style: normal;\n        font-display: swap;\n        src: url(").concat(_RivieraNightsBold.default, ") format('woff2'), url(").concat(_RivieraNightsBold2.default, ") format('woff');\n      }\n\n      @font-face {\n        font-family: 'Riviera Nights Ultralight';\n        font-weight: 100;\n        font-style: normal;\n        font-display: swap;\n        src: url(").concat(_RivieraNightsUltralight.default, ") format('woff2'), url(").concat(_RivieraNightsUltralight2.default, ") format('woff');\n      }");
      break;

    default:
      break;
  }

  return "\n    ".concat(defaultFontString, "\n    ").concat(fontString, "\n  ");
};

exports.getFontString = getFontString;
var _default = fonts;
exports.default = _default;